import { useExportWizardModalContext } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_modal_provider";
import { ExportType, Frequency } from "PFApp/booking/types/export_booking";
import MultiToggle from "PFComponents/multi_toggle";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getTemplateReportType } from "../../../helpers";
import css from "./frequency_selector.module.scss";

export const FrequencySelector = (): JSX.Element => {
  const {
    updateData,
    state: {
      data: { exportType, frequency, selectedTemplate }
    }
  } = useExportWizardModalContext();
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports" });

  const options: { id: Frequency; value: string }[] = useMemo(
    () => [
      { id: Frequency.Daily, value: t("frequency.daily") },
      { id: Frequency.Weekly, value: t("frequency.weekly") },
      { id: Frequency.Monthly, value: t("frequency.monthly") }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback(
    (frequency: Frequency) => {
      updateData({
        frequency,
        selectedFields: [],
        ...(exportType === ExportType.Template
          ? {
              exportType: ExportType.Custom,
              ...(selectedTemplate ? { reportType: getTemplateReportType(selectedTemplate) } : {})
            }
          : {})
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [exportType, selectedTemplate]
  );

  return (
    <div>
      <p className={css.label}>{t("exportWizard.fields.frequencyLabel")}</p>
      <MultiToggle<Frequency>
        classes={{ container: css.frequencySelector }}
        defaultSelected={frequency}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};
